const initialQuestions = [
    {
      id: 1,
      question: 'How many Probes and Sensors are required?',
      description: 'Select based on your total monitoring needs - this determines the PROTEUS model type and input capacity',
      options: [
        '4 or less Probes / 16 or less Sensors',
        '5 to 8 Probes and 0 Sensors',
        '5 or more Probes and 1 or more Sensors',
        '9 or more Probes',
        '17 or more Sensors'
      ],
      hardStop: (answer) => [
        '5 or more Probes and 1 or more Sensors',
        '9 or more Probes',
        '17 or more Sensors'
      ].includes(answer),
      hardStopMessage: 'Your needs exceed the Proteus K models and we recommend an X model. Please call Omntec Sales Rep at 1-888-XXX-XXXX'
    },
    {
        id: 2,
      question: 'Does this application require wireless probes?',
      description: 'Wireless probes eliminate the need for direct wiring between probes and console',
      options: ['Yes', 'No'],
      hardStop: (answer) => answer === 'Yes',
      hardStopMessage: 'Your needs exceed the Proteus K models and we recommend an X model. Please call Omntec Sales Rep at 1-888-XXX-XXXX'
    },
    {
        id: 3,
        question: 'Do you need a built in Thermal printer on the PROTEUS?',
        description: 'Select if you need a built in thermal printer on the PROTEUS',
        options: ['Yes', 'No']
    },
    {
      id: 4,
      question: 'Do you need to mount the PROTEUS outdoors?',
      description: 'For outdoor installations, weather-resistant models are required',
      options: ['Yes', 'No']
    },
    {
        id: 5,
        question: 'Proteus contains 5 relay outputs standard. How many ADDITIONAL relays do you need?',
        description: 'All relays are dry contact, 6 amp rated.',
        options: ['None', '1-8', '9+'],
        hardStop: (answer, allAnswers) => {
            // Hard stop if 9+ selected (always)
            if (answer === '9+') return true;
            // Hard stop if outdoor AND 1-8 relays selected
            const outdoorAnswer = allAnswers['Do you need to mount the PROTEUS outdoors?'];
            return outdoorAnswer === 'Yes' && answer === '1-8';
        },
        hardStopMessage: 'Your needs exceed the Proteus K models and we recommend an X model. Please call Omntec Sales Rep at 1-888-XXX-XXXX'
    },
    {
      id: 6,
      question: 'Are additional Communication Protocols such as Modbus or BACnet required?',
      description: 'Other than the required/included, are additional Communication Protocols such as Modbus or BACnet required for system integration?',
      options: ['None', 'BACnet', 'MODBUS TCP module', 'MODBUS Serial module'],
      hardStop: (answer, allAnswers) => {
        // Hard stop if 1-8 relays selected AND BACnet selected
        const relayAnswer = allAnswers['Proteus contains 5 relay outputs standard. How many ADDITIONAL relays do you need?'];
        return relayAnswer === '1-8' && answer === 'BACnet';
      },
      hardStopMessage: 'Your needs exceed the Proteus K models and we recommend an X model. Please call Omntec Sales Rep at 1-888-XXX-XXXX'
    },
    {
      id: 7,
      question: 'How many 4-20mA Analog Outputs are required?',
      description: 'PROTEUS 4 to 20 MA Interface Modules allow for remote real-time data monitoring of ATG tank levels. Specify the number of analog outputs needed for variable control signals.',
      options: ['None', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())],
      hardStop: (answer, allAnswers) => {
        // Hard stop if Analog Outputs != None AND relay != None
        const relayAnswer = allAnswers['Proteus contains 5 relay outputs standard. How many ADDITIONAL relays do you need?'];
        return answer !== 'None' && relayAnswer !== 'None';
      },
      hardStopMessage: 'Your needs exceed the Proteus K models and we recommend an X model. Please call Omntec Sales Rep at 1-888-XXX-XXXX'
    }
  ];


export const questions = [
  // PROTEUS CONSOLE QUESTIONS
  { 
    id: 1, 
    section: 'PROTEUS CONSOLE QUESTIONS', 
    question: 'How many Tanks/Probes, for level monitoring?',
    description: 'Specify the total number of tanks requiring level monitoring probes',
    getOptions: (answers) => {
      // Limit options based on the first initial question answer
      const probesAndSensors = answers['How many Probes and Sensors are required?'];
      
      if (probesAndSensors === '4 or less Probes / 16 or less Sensors') {
        // K4 models: limit to 1-4 tanks
        return Array.from({ length: 4 }, (_, i) => (i + 1).toString());
      } else if (probesAndSensors === '5 to 8 Probes and 0 Sensors') {
        // K8 models: limit to 1-8 tanks
        return Array.from({ length: 8 }, (_, i) => (i + 1).toString());
      }
      
      // Default fallback (shouldn't normally reach here)
      return Array.from({ length: 8 }, (_, i) => (i + 1).toString());
    }
  },
  { 
    id: 2, 
    section: 'PROTEUS CONSOLE QUESTIONS', 
    question: 'AST OR UST?',
    description: 'Specify if tanks are Above Ground Storage Tanks (AST) or Underground Storage Tanks (UST)',
    options: ['AST', 'UST']
  },
  { 
    id: 3, 
    section: 'PROTEUS CONSOLE QUESTIONS', 
    question: 'FACTORY PROGRAMMING?',
    description: 'Option for pre-configured programming from factory based on your specifications',
    options: ['Yes', 'No']
  },
  // Communication protocols question moved to initialQuestions
  { 
    id: 4,
    section: 'PROTEUS CONSOLE QUESTIONS',
    question: 'Please select a BACnet device that supports your protocol requirements.',
    description: 'Select the appropriate BACnet controller based on your communication protocol needs.',
    note: 'If you are not sure, then select the "BACnet Controller - TBD" option.',
    options: [
      'Modbus RTU over RS232 to BACnet IP',
      'Modbus RTU over RS485 to BACnet IP',
      'Modbus TCP to BACnet IP',
      'Modbus RTU over RS232 to BACnet MS/TP',
      'Modbus RTU over RS485 to BACnet MS/TP',
      'Modbus TCP to BACnet MS/TP',
      'BACnet Controller - TBD'
    ]
  },
  { 
    id: 5,
    section: 'PROTEUS CONSOLE QUESTIONS',
    question: 'How many additional serial communication (RS232/ RS485) ports are needed on the Proteus?',
    description: 'The Proteus K controller comes with 1 standard RS-232 port. The Proteus X controller comes with 1 standard RS-232 port and 1 configurable RS232 or RS485 board.',
    getOptions: (model) => {
        // Default to K series behavior if no model specified
        if (!model) return ['0', '1', '2'];
        
        if (model.includes('K') || model.includes('k')) {
            return ['0', '1', '2'];
        } else if (model.includes('X') || model.includes('x')) {
            return ['0', '1'];
        }
        return ['0'];
    }
  },
  { 
    id: 6, 
    section: 'PROTEUS CONSOLE QUESTIONS',
    question: 'How many additional relays are needed?',
    description: 'Proteus comes standard with 5 relays. Specify the number of digital outputs needed for external device control',
    getOptions: (initialRecommendation) => {
      // Proteus K supports max 8 additional relays (1 XC-R8 module)
      // Proteus X supports max 32 additional relays (4 XB-RB8 modules)
      const maxRelays = initialRecommendation && initialRecommendation.includes('X') ? 32 : 8;
      return ['None', ...Array.from({ length: maxRelays }, (_, i) => (i + 1).toString())];
    }
  },
  // Analog outputs question moved to initialQuestions
  
  // LEAK SENSORS QUESTIONS - Keep the dependency order
  { 
    id: 8, 
    section: 'LEAK SENSORS QUESTIONS', 
    question: 'How many Total Leak Sensors?',
    description: 'Total number of leak sensors needed across all monitoring points. Proteus Recommendation will be used to determine the maximum number of sensors you may select here.',
    getOptions: (initialRecommendation) => {
      // Set max sensors based on recommended model type
      const maxSensors = initialRecommendation && initialRecommendation.includes('X') ? 64 : 16;
      return ['0', ...Array.from({ length: maxSensors }, (_, i) => (i + 1).toString())];
    }
  },
  { 
    id: 9, 
    section: 'LEAK SENSORS QUESTIONS', 
    question: 'How many Sump / Dispenser Sensors?',
    description: 'Number of sensors needed for monitoring sumps and dispensers',
    options: (answers) => {
      const totalSensors = parseInt(answers['How many Total Leak Sensors?']) || 0;
      const currentIntersticeValue = parseInt(answers['How many Interstice Sensors?']) || 0;
      // Generate options with disabled state based on what's left after interstice allocation
      return Array.from({ length: totalSensors + 1 }, (_, i) => ({
        value: i.toString(),
        disabled: i > (totalSensors - currentIntersticeValue)
      }));
    }
  },
  { 
    id: 10, 
    section: 'LEAK SENSORS QUESTIONS', 
    question: 'How many Interstice Sensors?',
    description: 'Number of sensors needed for interstitial space monitoring',
    options: (answers) => {
      const totalSensors = parseInt(answers['How many Total Leak Sensors?']) || 0;
      const currentSumpValue = parseInt(answers['How many Sump / Dispenser Sensors?']) || 0;
      // Generate options with disabled state based on what's left after sump allocation
      return Array.from({ length: totalSensors + 1 }, (_, i) => ({
        value: i.toString(),
        disabled: i > (totalSensors - currentSumpValue)
      }));
    }
  },
  { 
    id: 11, 
    section: 'LEAK SENSORS QUESTIONS', 
    question: 'Is the interstice wet(BRINE)?',
    description: 'Specify if the interstitial space uses brine for leak detection',
    options: ['Yes', 'No']
  },
  { 
    id: 12, 
    section: 'LEAK SENSORS QUESTIONS', 
    question: "Sensors Cable(EC-4 1000'/SPOOLS)?",
    description: 'Number of cable spools needed for sensor connections',
    options: ['0', '1', '2', '3', '4']
  },
  { 
    id: 13, 
    section: 'LEAK SENSORS QUESTIONS', 
    question: 'Is Product Distinguishing required for Interstice?',
    description: 'Specify if sensors need to identify specific products in the interstitial space',
    options: ['Yes', 'No']
  },
  {
    id: 14,
    section: 'LEAK SENSORS QUESTIONS',
    question: 'Is Product Distinguishing required for Sump/Dispenser Sensors?',
    description: 'Specify if the Sump/Dispenser sensors need to identify specific products',
    options: ['Yes', 'No']
  },
  { 
    id: 15, 
    section: 'LEAK SENSORS QUESTIONS', 
    question: 'Opening for Interstice Sensor?',
    description: 'Select the available opening size for interstice sensor installation',
    options: ['2-inch', '4-inch', '1-inch']
  },
  { 
    id: 16, 
    section: 'LEAK SENSORS QUESTIONS',  
    question: '2-conductor field wiring for interstice sensors?',
    description: 'Specify if 2-conductor field wiring is needed for sensor installation. BX Sensors use 4 Conductor Wiring standard. 2 Conductor sensors are available, but require a BX-UT converter for each 2 conductor line.',
    options: ['Yes', 'No']
  },
  {
    id: 17,
    section: 'LEAK SENSORS QUESTIONS',
    question: '2-conductor field wiring for sump/dispenser sensors?',
    description: 'Specify if 2-conductor field wiring is needed for sensor installation. BX Sensors use 4 Conductor Wiring standard. 2 Conductor sensors are available, but require a BX-UT converter for each 2 conductor line.',
    options: ['Yes', 'No']
  },
  
  // PROBE QUESTIONS
  { 
    id: 18, 
    section: 'PROBE QUESTIONS', 
    question: 'Would you like VLD or CITLD CODE-P?',
    description: 'Choose between Volumetric Line Detection or Continuous In-Tank Leak Detection with CODE-P certification',
    options: ['None','CITLD Code-P', 'VLD']
  },
  { 
    id: 19, 
    section: 'PROBE QUESTIONS', 
    question: 'Leak Detection probe (i.e. 0.2gph/ 0.1gph Leak Detection probe), or Inventory only probe?',
    description: 'Select between high-precision leak detection or basic inventory monitoring probes',
    options: ['Leak Detection probe', 'Inventory only probe']
  },
  { 
    id: 20, 
    section: 'PROBE QUESTIONS', 
    question: 'Probe Length',
    description: 'Select the appropriate probe length based on your tank depth requirements. Typically Tank diameter/ height + 12"',
    options: ['20" to 83"','84" to 95"','96" to 107"','108" to 119"','120" to 132"','133" to 144"','145" to 156"','157" to 168"','169" to 180"','181" to 204"','205" to 228"','229" to 240"','241" to 252"','253" to 263"','264" to 276"','277" to 288"']
  },
  { 
    id: 21, 
    section: 'PROBE QUESTIONS', 
    question: 'Inside diameter of tanks?',
    description: 'Select the internal diameter of your tanks for proper probe sizing',
    options: ['4 Foot', '6 foot', '8 foot', '10 foot', '12 Foot', 'Other']
  },
  { 
    id: 22, 
    section: 'PROBE QUESTIONS', 
    question: 'What is the Product / Fuel Type in each Tank?',
    description: 'Specify the type of product or fuel being stored in each tank',
    options: ['DEF', 'UNLEADED GAS', 'DIESEL', 'OTHER']
  },
  { 
    id: 23, 
    section: 'PROBE QUESTIONS', 
    question: 'Opening for Probe?',
    description: 'Select the available opening size for probe installation',
    options: ['2 inch', '4 inch', 'OTHER']
  },
  { 
    id: 24, 
    section: 'PROBE QUESTIONS', 
    question: "Probe cable(EC-2 500'/SPOOLS). How Many Spools?",
    description: 'Number of cable spools needed for probe connections',
    options: ['0', '1', '2', '3', '4']
  },
  
  // TANK QUESTIONS
  { 
    id: 25, 
    section: 'TANK QUESTIONS', 
    question: 'Tank Material Type?',
    description: 'Specify the construction material of your tanks',
    options: ['Steel', 'Fiberglass']
  },
  
  // REMOTE ALARMS
  { 
    id: 26, 
    section: 'REMOTE ALARMS', 
    question: 'How many Fill locations for remote overflow alarms?',
    description: 'Specify the number of fill locations that require remote overflow alarms',
    options: ['None', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
  },
  { 
    id: 27, 
    section: 'REMOTE ALARMS', 
    question: 'Remote Overfill Alarm?',
    description: 'Select the type of remote alarm system for overfill protection',
    options: ['RAS-1-NYS', 'RAS-1', 'RAS-2', 'RAS-3', 'RAS-4', 'DDL-1', 'DDL-2', 'DDL-3', 'DDL-4']
  },
  { 
    id: 28, 
    section: 'REMOTE ALARMS', 
    question: "RAS Alarm cable (EC-6) for RAS-1 to RAS-3. How Many Spools?",
    description: 'Number of 1000ft EC-6 cable spools needed for RAS-1-NYS, RAS-1, RAS-2, or RAS-3 alarm installations',
    options: ['0', '1', '2', '3', '4']
  },
  { 
    id: 29, 
    section: 'REMOTE ALARMS', 
    question: "RAS Alarm cable (EC-12) for RAS-4. How Many Spools?",
    description: 'Number of 1000ft EC-12 cable spools needed for RAS-4 alarm installations',
    options: ['0', '1', '2', '3', '4']
  },
  { 
    id: 30, 
    section: 'REMOTE ALARMS', 
    question: "DDL Alarm cable (EC-4). How Many Spools?",
    description: 'Number of 1000ft EC-4 cable spools needed for DDL-1, DDL-2, DDL-3, or DDL-4 alarm installations',
    options: ['0', '1', '2', '3', '4']
  }
];
const getFilteredSections = () => {
    // Get unique sections while preserving order
    const uniqueSections = [];
    questions.forEach(q => {
        if (!uniqueSections.includes(q.section)) 
        {
            uniqueSections.push(q.section);
        }
    });

    // Map sections to their questions while preserving order
    return uniqueSections.map(section => ({
        name: section,
        questions: questions
            .filter(q => q.section === section)
            .sort((a, b) => a.id - b.id)
            .map(q => q.question)
    }));
};

const availableModels = [
  "OEL8000IIIK4P-5", 
  "OEL8000IIIK4P-5-SS", 
  "OEL8000IIIK4-5",
  "OEL8000IIIK4-5-SS",
  "OEL8000IIIK8P-5",
  "OEL8000IIIK8P-5-SS",
  "OEL8000IIIK8-5", 
  "OEL8000IIIK8-5-SS", 
  "OEL8000IIIX-5",
  "OEL8000IIIXP-5", 
  "OEL8000IIIX-5-W", 
  "OEL8000IIIX-5(*Enclosure Required)", 
  "OEL8000IIIX-5-W(*Enclosure Required)"
];

function determineInitialRecommendation(answers) {
    let selectedModels = [...availableModels];

    // TEMPORARILY COMMENTED OUT - X models disabled until logic is finalized
    // Check total sensors first
    // const totalSensors = parseInt(answers['How many Total Leak Sensors?']) || 0;
    // if (totalSensors > 16) {
    //     // Filter to only X models that can handle more than 16 sensors
    //     selectedModels = selectedModels.filter(model => 
    //         model.includes('X') && 
    //         !model.includes('K')
    //     );
    // }

    // Question 1: Filter based on the number of probes and sensors
    if (answers['How many Probes and Sensors are required?'] === '4 or less Probes / 16 or less Sensors') {
        // For 4 or less probes and 16 or less sensors, we should filter out both K8 models and X models
        selectedModels = selectedModels.filter(model => 
            ![
                "OEL8000IIIK8-5", 
                "OEL8000IIIK8-5-SS",
                "OEL8000IIIK8P-5",
                "OEL8000IIIK8P-5-SS",
                "OEL8000IIIX-5",
                "OEL8000IIIXP-5",
                "OEL8000IIIX-5-W",
                "OEL8000IIIX-5(*Enclosure Required)",
                "OEL8000IIIX-5-W(*Enclosure Required)"
            ].includes(model)
        );
    }
    else if (answers['How many Probes and Sensors are required?'] === '5 to 8 Probes and 0 Sensors') 
    {
        // Filter to only K8 models - remove K4 and X models
        selectedModels = selectedModels.filter(model => 
            model !== "OEL8000IIIK4P-5" && 
            model !== "OEL8000IIIK4P-5-SS" && 
            model !== "OEL8000IIIK4-5" && 
            model !== "OEL8000IIIK4-5-SS" &&
            !model.includes('X')  // Remove all X models
        );
        
    }
    // TEMPORARILY COMMENTED OUT - X models disabled until logic is finalized
    // else if (answers['How many Probes and Sensors are required?'] === '5 or more Probes and 1 or more Sensors')
    // {
    //     // Filter to only keep X variants
    //     selectedModels = selectedModels.filter(model => 
    //         model.includes('X')
    //     );
    //     
    //     // If printer is needed, ensure we select the XP-5 model
    //     if (answers['Do you need a built in Thermal printer on the PROTEUS?'] === 'Yes') {
    //         const xpModel = selectedModels.find(model => model === "OEL8000IIIXP-5");
    //         if (xpModel) {
    //             selectedModels = [xpModel];
    //             return xpModel; // Return immediately to ensure this is the selected model
    //         }
    //     } else if (answers['Do you need a built in Thermal printer on the PROTEUS?'] === 'No') {
    //         // Remove printer models
    //         selectedModels = selectedModels.filter(model => !model.includes('P-5'));
    //     }
    // }   

    // Stop if only one model remains
    if (selectedModels.length === 1) 
    {
        //console.log("Final model after Question 1:", selectedModels[0]);
        return selectedModels[0];
    }

    // Question 1.5: Filter based on the need for a built in Thermal printer
    if (answers['Do you need a built in Thermal printer on the PROTEUS?'] === 'Yes') 
    {
        selectedModels = selectedModels.filter(model => 
            ![
                "OEL8000IIIK4-5",
                "OEL8000IIIK4-5-SS",
                "OEL8000IIIK8-5",
                "OEL8000IIIK8-5-SS",
                "OEL8000IIIX-5"
            ].includes(model)
        );
        
        // If we're down to just X models and need a printer, ensure we select the XP-5 model
        if (selectedModels.every(model => model.includes('X'))) {
            // Keep only the XP-5 model if it's in the list
            const xpModel = selectedModels.find(model => model === "OEL8000IIIXP-5");
            if (xpModel) {
                selectedModels = [xpModel];
                return xpModel; // Return immediately to ensure this is the selected model
            }
        }
    }
    else if (answers['Do you need a built in Thermal printer on the PROTEUS?'] === 'No')
    {
        selectedModels = selectedModels.filter(model => 
            ![
                "OEL8000IIIK4P-5",
                "OEL8000IIIK4P-5-SS",
                "OEL8000IIIK8P-5",
                "OEL8000IIIK8P-5-SS",
                "OEL8000IIIXP-5"
            ].includes(model)
        );
    }

    // Question 2: Mounting outdoors
    if (answers['Do you need to mount the PROTEUS outdoors?'] === 'Yes') 
    {
        // Check if any feature requires an indoor console with outdoor enclosure
        const needsPrinter = answers['Do you need a built in Thermal printer on the PROTEUS?'] === 'Yes';
        const needsBACnet = answers['Are additional Communication Protocols such as Modbus or BACnet required?'] === 'BACnet';
        const needsAnalogOutputs = answers['How many 4-20mA Analog Outputs are required?'] && 
                                   answers['How many 4-20mA Analog Outputs are required?'] !== 'None';
        
        // Special case: If printer, BACnet, or 4-20mA is required AND outdoor is required,
        // use indoor model with outdoor enclosure accessories
        if (needsPrinter || needsBACnet || needsAnalogOutputs) {
            // Keep indoor models, remove SS (outdoor) models
            selectedModels = selectedModels.filter(model => 
                ![
                    "OEL8000IIIK4P-5-SS",
                    "OEL8000IIIK4-5-SS",
                    "OEL8000IIIK8P-5-SS",
                    "OEL8000IIIK8-5-SS",
                    "OEL8000IIIX-5(*Enclosure Required)", 
                    "OEL8000IIIX-5-W(*Enclosure Required)"
                ].includes(model)
            );
            //console.log("Filtered models after Question 2 (Outdoor + special features - using indoor model):", selectedModels);
        } else {
            // Standard outdoor selection - use SS models
        selectedModels = selectedModels.filter(model => 
            ![
                "OEL8000IIIK4P-5",
                "OEL8000IIIK8-5",
                "OEL8000IIIK8P-5",
                "OEL8000IIIK4-5",
                "OEL8000IIIX-5", 
                "OEL8000IIIX-5-W",
                "OEL8000IIIXP-5"
            ].includes(model)
        );
        //console.log("Filtered models after Question 2 (Mount outdoors - Yes):", selectedModels);
        }
    } 
    else if (answers['Do you need to mount the PROTEUS outdoors?'] === 'No') 
    {
        selectedModels = selectedModels.filter(model => 
            ![
                "OEL8000IIIK4P-5-SS", 
                "OEL8000IIIK8-5-SS", 
                "OEL8000IIIK8P-5-SS",
                "OEL8000IIIK4-5-SS",
                "OEL8000IIIX-5(*Enclosure Required)", 
                "OEL8000IIIX-5-W(*Enclosure Required)"
            ].includes(model)
        );
        //console.log("Filtered models after Question 2 (Mount outdoors - No):", selectedModels);
    }

    // Stop if only one model remains
    if (selectedModels.length === 1) 
    {
        //console.log("Final model after Question 2:", selectedModels[0]);
        return selectedModels[0];
    }

    // Question 3: Filter based on dry contact outputs
    // Note: '9+' triggers a hard stop so we only handle 'None' and '1-8' here
    if (answers['Proteus contains 5 relay outputs standard. How many ADDITIONAL relays do you need?'] === '1-8') 
    {
        // 1-8 additional relays still works with K models (max 8 additional via XC-R8)
        //console.log("Filtered models after Question 3 (1-8 relay outputs):", selectedModels);
    } 
    else if (answers['Proteus contains 5 relay outputs standard. How many ADDITIONAL relays do you need?'] === 'None') 
    {
        //console.log("Filtered models after Question 3 (No additional relay outputs):", selectedModels);
    }

    // Stop if only one model remains
    if (selectedModels.length === 1) 
    {
        //console.log("Final model after Question 3:", selectedModels[0]);
        return selectedModels[0];
    }

    // TEMPORARILY COMMENTED OUT - LLD question disabled until logic is finalized
    // Question 4: Filter based on LLD Integration
    // if (answers['Do you require LLD Integrated?'] === 'Yes') 
    // {
    //     selectedModels = selectedModels.filter(model => 
    //         ![
    //             "OEL8000IIIK4P-5", 
    //             "OEL8000IIIK4P-5-SS", 
    //             "OEL8000IIIK8-5", 
    //             "OEL8000IIIK8-5-SS",
    //             "OEL8000IIIK8P-5",
    //             "OEL8000IIIK8P-5-SS",
    //             "OEL8000IIIK4-5",
    //             "OEL8000IIIK4-5-SS"
    //         ].includes(model)
    //     );
    //     //console.log("Filtered models after Question 4 (LLD Integrated - Yes):", selectedModels);
    // } 
    // else if (answers['Do you require LLD Integrated?'] === 'No') 
    // {
    //   
    //     //console.log("Filtered models after Question 4 (LLD Integrated - No):", selectedModels);
    // }

    // Stop if only one model remains
    if (selectedModels.length === 1) 
    {
        //console.log("Final model after Question 4:", selectedModels[0]);
        return selectedModels[0];
    }

    // Stop if only one model remains
    if (selectedModels.length === 1) 
    {
        //console.log("Final model after Question 5:", selectedModels[0]);
        return selectedModels[0];
    }

    //Combined questions 3-5 filter for NO/None answers
    // TEMPORARILY UPDATED - LLD question disabled, so removed that condition check
    if(answers['Proteus contains 5 relay outputs standard. How many ADDITIONAL relays do you need?'] === 'None' /* && answers['Do you require LLD Integrated?'] === 'No' */ /* && answers['Do you need LATCHING relays?'] === 'No' */)
    {
        // Filter out X models since X option is temporarily disabled
        selectedModels = selectedModels.filter(model => 
          ![
              "OEL8000IIIX-5",
              "OEL8000IIIX-5(*Enclosure Required)",
              "OEL8000IIIXP-5"
          ].includes(model)
        );
        //console.log("Filtered models after Questions 3-5:", selectedModels);
    }


    // Question 6: Filter based on wireless probes
    if (answers['Does this application require wireless probes?'] === 'Yes') 
    {
        selectedModels = selectedModels.filter(model => 
            ![
                "OEL8000IIIK4P-5", 
                "OEL8000IIIK4P-5-SS", 
                "OEL8000IIIK8-5", 
                "OEL8000IIIK8-5-SS", 
                "OEL8000IIIK8P-5",
                "OEL8000IIIK8P-5-SS",
                "OEL8000IIIK4-5",
                "OEL8000IIIK4-5-SS",
                "OEL8000IIIX-5",
                "OEL8000IIIX-5(*Enclosure Required)"
            ].includes(model)
        );
        //console.log("Filtered models after Question 6 (Wireless probes - Yes):", selectedModels);
    } 
    else if (answers['Does this application require wireless probes?'] === 'No') 
    {
        selectedModels = selectedModels.filter(model => 
            ![
                "OEL8000IIIX-5-W",
                "OEL8000IIIX-5-W(*Enclosure Required)"
            ].includes(model)
        );
        //console.log("Filtered models after Question 6 (Wireless probes - No):", selectedModels);
    }

    // Stop if only one model remains
    if (selectedModels.length === 1) 
    {
        //console.log("Final model after Question 6:", selectedModels[0]);
        return selectedModels[0];
    }

    // Final check: If no models match or multiple models left
    if (selectedModels.length === 0) 
    {
        //console.log("No suitable models found.");
        return null;  // No suitable model found
    } 
    else 
    {
        // Final check for X models with printer requirement
        if (selectedModels.some(model => model.includes('X')) && 
            answers['Do you need a built in Thermal printer on the PROTEUS?'] === 'Yes') {
            
            // If we need a printer and have X models, prioritize OEL8000IIIXP-5
            const xpModel = "OEL8000IIIXP-5";
            if (availableModels.includes(xpModel)) {
                return xpModel;
            }
        }
        
        //console.log("Final list of models:", selectedModels);
        return selectedModels.length === 1 ? selectedModels[0] : selectedModels;  // Return the remaining models
    }
}

const determineFinalRecommendation = (initialModel, answers) => {
    let accessories = [];
    const tankCount = parseInt(answers['How many Tanks/Probes, for level monitoring?']) || 1;
    const totalSensors = parseInt(answers['How many Total Leak Sensors?']) || 0;
    let slotCount = 0;
    let slotExceeded = false;

    // Add outdoor mounting accessories only for indoor models being used outdoors
    // SS (Stainless Steel) models are already outdoor-rated and don't need enclosure accessories
    if (answers['Do you need to mount the PROTEUS outdoors?'] === 'Yes') {
        const isSSModel = initialModel && initialModel.includes && initialModel.includes('-SS');
        
        // Only add enclosure accessories for indoor K models being used outdoors
        if (initialModel && initialModel.includes && initialModel.includes('K') && !isSSModel) {
            accessories.push('MOUNTING FEE');
            accessories.push('ENC-4X');
            accessories.push('HTR-1');
            accessories.push('TEM-CS');
        }
        // SS models don't need enclosure accessories - they're already outdoor-rated
    }

    // Handle per-tank accessories
    for (let i = 0; i < tankCount; i++) {
        const probeModel = determineProbeModel(answers, i);
        if (probeModel) {
            accessories.push(probeModel);
        }

        // Only add sensor accessories if not using K8-5 models
        if (initialModel !== 'OEL8000IIIK8-5' && initialModel !== 'OEL8000IIIK8-5-SS') {
            const tankSensors = determineTankSensors(answers, i);
            if (tankSensors) 
            {
                accessories.push(...tankSensors);
            }
        }
    }

    // Handle additional serial ports
    const additionalPorts = answers['How many additional serial communication (RS232/ RS485) ports are needed on the Proteus?'];
    if (additionalPorts && additionalPorts !== '0') 
    {
        accessories.push(`MB-232/485`);
    }

    // Handle AST/UST logic
    if (answers['AST OR UST?'] && answers['AST OR UST?'].every(value => value === 'AST')) 
    {
        if (answers['Leak Detection probe'] !== 'Inventory only probe') 
        {
            answers['Leak Detection probe'] = 'Inventory only probe';
        }
    } 
    
    else if (answers['Would you like VLD or CITLD CODE-P?'] === 'CITLD Code-P')
    {
        accessories.push('CITLD CODE-P module');
    }

    // Handle Communication Protocols
    const selectedProtocol = answers['Are additional Communication Protocols such as Modbus or BACnet required?'];
    if (selectedProtocol && selectedProtocol !== 'None') {
        if (selectedProtocol === 'BACnet') {
            // Use the specific BACnet device selected in the detailed question
            const bacnetDevice = answers['Please select a BACnet device that supports your protocol requirements.'];
            const bacnetDeviceMap = {
                'Modbus RTU over RS232 to BACnet IP': 'C232-BAC',
                'Modbus RTU over RS485 to BACnet IP': 'C485-BAC',
                'Modbus TCP to BACnet IP': 'CTCP/IP-BAC',
                'Modbus RTU over RS232 to BACnet MS/TP': 'C232-BAC-MSTP',
                'Modbus RTU over RS485 to BACnet MS/TP': 'C485-BAC-MSTP',
                'Modbus TCP to BACnet MS/TP': 'CTCP/IP-BAC-MSTP',
                'BACnet Controller - TBD': 'BACnet Controller TBD'
            };
            if (bacnetDevice && bacnetDeviceMap[bacnetDevice]) {
                accessories.push(bacnetDeviceMap[bacnetDevice]);
            } else {
                // Fallback to generic BACnet module if no specific device selected
                accessories.push('BACnet module');
            }
        } else if (selectedProtocol === 'MODBUS TCP module') {
            accessories.push('MODBUS TCP module');
        } else if (selectedProtocol === 'MODBUS Serial module') {
            accessories.push('MODBUS Serial module');
        }
    }

    // Handle outputs
    ['Digital', 'Analog'].forEach(type => {
        if (answers[`How Many (${type} outs)?`] && answers[`How Many (${type} outs)?`] !== 'None') {
            accessories.push(`${answers[`How Many (${type} outs)?`]} ${type} Outputs`);
        }
    });

    // Handle Remote Overfill Alarm
    const fillLocationsAnswer = answers['How many Fill locations for remote overflow alarms?'];
    if (fillLocationsAnswer && fillLocationsAnswer !== 'None') {
        const fillLocations = parseInt(fillLocationsAnswer) || 0;
        for (let i = 0; i < fillLocations; i++) {
            const locationAlarm = answers[`Remote Overfill Alarm? - Location ${i + 1}`];
            if (locationAlarm) {
                accessories.push(`Remote Overfill Alarm: ${locationAlarm}`);
            }
        }
    }

    // Handle Factory Programming
    if (answers['FACTORY PROGRAMMING?'] === 'Yes') 
    {
        accessories.push('PPF');
    }

    // TEMPORARILY COMMENTED OUT - LLD question disabled until logic is finalized
    // if (answers['Do you require LLD Integrated?'] === 'Yes')
    // {
    //     //LD2000 or LD3000 accesories push. probably needs multiplier
    //     accessories.push('LD2000');
    // }

    // SLOT CALCULATION LOGIC
    // Only proceed with slot calculations if using a Proteus X model
    if (initialModel && initialModel.includes && initialModel.includes('X')) {
        // Base Proteus X can handle 4 probes and 16 sensors without expansion
        let remainingProbes = Math.max(0, tankCount - 4);
        let remainingSensors = Math.max(0, totalSensors - 16);
        
        console.log(`Slot calculation: ${tankCount} tanks (${remainingProbes} remaining) and ${totalSensors} sensors (${remainingSensors} remaining)`);
        
        // Calculate how many XB-800 boards we need for remaining probes
        // Each XB-800 can handle 8 probes
        let xb800Count = 0;
        if (remainingProbes > 0) {
            xb800Count = Math.ceil(remainingProbes / 8);
            slotCount += xb800Count;
            console.log(`Need ${xb800Count} XB-800 boards for probes, slot count now: ${slotCount}`);
        }
        
        // Calculate how many XB-416 boards we need for remaining sensors
        // Each XB-416 can handle 16 sensors
        let xb416Count = 0;
        if (remainingSensors > 0) {
            xb416Count = Math.ceil(remainingSensors / 16);
            slotCount += xb416Count;
            console.log(`Need ${xb416Count} XB-416 boards for sensors, slot count now: ${slotCount}`);
        }
        
        // Add all required boards to the accessories list, regardless of slot limit
        // This ensures the quote shows all the hardware that would be needed
        for (let i = 0; i < xb800Count; i++) {
            accessories.push('XB-800');
        }
        
        for (let i = 0; i < xb416Count; i++) {
            accessories.push('XB-416');
        }
        
        console.log(`Final slot count: ${slotCount}, maximum allowed: 5, exceeded: ${slotCount > 5}`);
    }

    // Check if slot count exceeds maximum
    if (slotCount > 5) {
        accessories.push('Contact Omntec for additional slot solutions');
        slotExceeded = true;
    }
    
    // Handle cables
    const cableTypes = {
        'RAS Alarm cable(EC-6 1000\'/SPOOLS)': 'EC-6',
        'Probe cable(EC-2 500/SPOOLS)': 'EC-2',
        'Sensors Cable(EC-4 1000/SPOOLS)?': 'EC-4'
    };

    Object.entries(cableTypes).forEach(([question, cableType]) => {
        if (answers[question] && answers[question] > 0) {
            accessories.push(`${cableType} x ${answers[question]}`);
        }
    });

    // Handle digital outputs
    const digitalOuts = answers['How many additional relays are needed?'];

    if (digitalOuts && digitalOuts !== 'None') 
    {
        if (initialModel.includes('K') && digitalOuts <= 8)
        {
            //limit this to one per proteus K max
            accessories.push('XC-R8');
        }
        else if (initialModel.includes('X') && digitalOuts <= 8 )
        {
            //limit this to 4 per proteus X max for the RB8's
            accessories.push('XB-RB8');
        }
        else if (initialModel.includes('X') && digitalOuts >= 9 && digitalOuts <= 16)
        {
            //limit this to 8 per proteus X max for the RB8's
            accessories.push('XB-RB8');
            accessories.push('XB-RB8');
        }
        else if (initialModel.includes('X') && digitalOuts >= 17 && digitalOuts <= 24)
        {
            //limit this to 8 per proteus X max for the RB8's
            accessories.push('XB-RB8');
            accessories.push('XB-RB8');
            accessories.push('XB-RB8');
        }
        else if (initialModel.includes('X') && digitalOuts >= 25 && digitalOuts <= 32)
        {
            //limit this to 8 per proteus X max for the RB8's
            accessories.push('XB-RB8');
            accessories.push('XB-RB8');
            accessories.push('XB-RB8');
            accessories.push('XB-RB8');
        }
    }

    // Handle analog outputs (check both old and new question key formats)
    const analogOuts = parseInt(answers['How many 4-20mA Analog Outputs are required?'] || answers['How many 4-20mA  Analog Outputs are required?']) || 0;
    if (analogOuts > 0) 
    {
        let analogPart;
        if (analogOuts <= 2) 
        {
            analogPart = 'X232-420-2-SRC';
        } 
        else if (analogOuts <= 6) 
        {
            analogPart = 'X232-420-6-SRC';
        } 
        else if (analogOuts <= 10) 
        {
            analogPart = 'X232-420-10-SRC';
        }
        if (analogPart) 
        {
            accessories.push(analogPart);
        }
    }

    // Handle sensor cables
    const sensorCables = parseInt(answers["Sensors Cable(EC-4 1000'/SPOOLS)?"]) || 0;
    if (sensorCables > 0) {
        accessories.push('EC-4');
    }

    // Handle probe cables
    const probeCables = parseInt(answers["Probe cable(EC-2 500'/SPOOLS). How Many Spools?"]) || 0;
    if (probeCables > 0) {
        accessories.push('EC-2');
    }

    // Handle RAS alarm cables (EC-6 for RAS-1 to RAS-3)
    const rasCablesEC6 = parseInt(answers["RAS Alarm cable (EC-6) for RAS-1 to RAS-3. How Many Spools?"]) || 0;
    if (rasCablesEC6 > 0) {
        accessories.push('EC-6');
    }

    // Handle RAS alarm cables (EC-12 for RAS-4 only)
    const rasCablesEC12 = parseInt(answers["RAS Alarm cable (EC-12) for RAS-4. How Many Spools?"]) || 0;
    if (rasCablesEC12 > 0) {
        accessories.push('EC-12');
    }

    // Handle DDL alarm cables (EC-4 for DDL devices)
    const ddlCablesEC4 = parseInt(answers["DDL Alarm cable (EC-4). How Many Spools?"]) || 0;
    if (ddlCablesEC4 > 0) {
        accessories.push('DDL-EC-4');
    }

    // Return both the accessories and the slot exceeded flag
    return { accessories, slotExceeded };
};

const determineProbeModel = (answers, tankIndex) => {
    const probeLength = answers[`Probe Length - Tank ${tankIndex + 1}`];
    const fuelType = answers[`What is the Product / Fuel Type in each Tank? - Tank ${tankIndex + 1}`];
    const probeOpening = answers[`Opening for Probe? - Tank ${tankIndex + 1}`];

    // Check for DEF first as it overrides all other probe logic
    if (fuelType === 'DEF') 
    {
        console.log("DEF tank detected");
        const defProbe = defProbeOptions.find(opt => opt.length === probeLength);
        console.log("defProbe:", defProbe);
        if (!defProbe) return null;

        const accessories = [];
        accessories.push(`Tank ${tankIndex + 1}: ${defProbe.model}`);

        // Add float kit based on opening size
        if (probeOpening === '2 inch') {
            accessories.push(`Tank ${tankIndex + 1}: SSFK2-SF`);
        } else if (probeOpening === '4 inch') {
            accessories.push(`Tank ${tankIndex + 1}: SSFK4-SF`);
        }

        // Add required SL-34 part for DEF tank
        accessories.push(`Tank ${tankIndex + 1}: SL-34`);
        console.log("accessories:", accessories);

        return accessories;
    }

    // For non-DEF tanks, determine probe type based on AST/UST
    const tankType = answers[`AST OR UST? - Tank ${tankIndex + 1}`];
    let probeType = tankType === 'AST' ? 
        'Inventory only probe' : 
        answers['Leak Detection probe (i.e. 0.2gph/ 0.1gph Leak Detection probe), or Inventory only probe?'];

    const options = probeType === 'Leak Detection probe' ? leakDetectionProbeOptions : inventoryProbeOptions;
    const probe = options.find(opt => opt.length === probeLength);
    
    return probe ? [`Tank ${tankIndex + 1}: ${probe.model}`] : null;
};

const determineTankSensors = (answers, tankIndex) => {
    const accessories = [];
    const totalSumpSensors = parseInt(answers['How many Sump / Dispenser Sensors?']) || 0;
    const totalIntersticeSensors = parseInt(answers['How many Interstice Sensors?']) || 0;
    
    // Handle sump/dispenser sensors - add them all at once if we're on the first tank
    if (tankIndex === 0) {  // Only process sump sensors on first pass
        for (let i = 0; i < totalSumpSensors; i++) {
            const sumpModels = determineSensorModel('sump', answers, i);
            if (sumpModels && sumpModels.length > 0) {
                sumpModels.forEach(model => {
                    accessories.push(model); // No tank prefix for sump sensors
                });
            }
        }
    }

    // Handle interstice sensors - keep tank prefix
    if (tankIndex < totalIntersticeSensors) {
        const intersticeSensorModels = determineSensorModel('interstice', answers, tankIndex);
        if (intersticeSensorModels && intersticeSensorModels.length > 0) {
            intersticeSensorModels.forEach(model => {
                accessories.push(`Tank ${tankIndex + 1}: ${model}`);
            });
        }
    }

    return accessories;
};

    // updateSensorLimits function removed - options are now calculated dynamically
    // in the questions array to prevent state caching issues between quotes

const leakDetectionProbeOptions = [
    { length: '20" to 83"', model: 'MTG-RS-R5F2-01' },
    { length: '84" to 95"', model: 'MTG-RS-R5F2-02' },
    { length: '96" to 107"', model: 'MTG-RS-R5F2-03' },
    { length: '108" to 119"', model: 'MTG-RS-R5F2-04' },
    { length: '120" to 132"', model: 'MTG-RS-R5F2-05' },
    { length: '133" to 144"', model: 'MTG-RS-R5F2-06' },
    { length: '145" to 156"', model: 'MTG-RS-R5F2-07' },
    { length: '157" to 168"', model: 'MTG-RS-R5F2-08' },
    { length: '169" to 180"', model: 'MTG-RS-R5F2-09' },
    { length: '181" to 204"', model: 'MTG-RS-R5F2-10' },
    { length: '205" to 228"', model: 'MTG-RS-R5F2-11' },
    { length: '229" to 240"', model: 'MTG-RS-R5F2-12' },
    { length: '241" to 252"', model: 'MTG-RS-R5F2-13' },
    { length: '253" to 263"', model: 'MTG-RS-R5F2-14' },
    { length: '264" to 276"', model: 'MTG-RS-R5F2-15' },
    { length: '277" to 288"', model: 'MTG-RS-R5F2-16' }
];

const inventoryProbeOptions = [
    { length: '20" to 83"', model: 'MTG-RS-R1F2-01' },
    { length: '84" to 95"', model: 'MTG-RS-R1F2-02' },
    { length: '96" to 107"', model: 'MTG-RS-R1F2-03' },
    { length: '108" to 119"', model: 'MTG-RS-R1F2-04' },
    { length: '120" to 132"', model: 'MTG-RS-R1F2-05' },
    { length: '133" to 144"', model: 'MTG-RS-R1F2-06' },
    { length: '145" to 156"', model: 'MTG-RS-R1F2-07' },
    { length: '157" to 168"', model: 'MTG-RS-R1F2-08' },
    { length: '169" to 180"', model: 'MTG-RS-R1F2-09' },
    { length: '181" to 204"', model: 'MTG-RS-R1F2-10' },
    { length: '205" to 228"', model: 'MTG-RS-R1F2-11' },
    { length: '229" to 240"', model: 'MTG-RS-R1F2-12' },
    { length: '241" to 252"', model: 'MTG-RS-R1F2-13' },
    { length: '253" to 263"', model: 'MTG-RS-R1F2-14' },
    { length: '264" to 276"', model: 'MTG-RS-R1F2-15' },
    { length: '277" to 288"', model: 'MTG-RS-R1F2-16' }
];

const defProbeOptions = [
    { length: '20" to 83"', model: 'MTG-RS-R1F1-01' },
    { length: '84" to 95"', model: 'MTG-RS-R1F1-02' },
    { length: '96" to 107"', model: 'MTG-RS-R1F1-03' },
    { length: '108" to 119"', model: 'MTG-RS-R1F1-04' },
    { length: '120" to 132"', model: 'MTG-RS-R1F1-05' },
    { length: '133" to 144"', model: 'MTG-RS-R1F1-06' },
    { length: '145" to 156"', model: 'MTG-RS-R1F1-07' },
    { length: '157" to 168"', model: 'MTG-RS-R1F1-08' },
    { length: '169" to 180"', model: 'MTG-RS-R1F1-09' },
    { length: '181" to 204"', model: 'MTG-RS-R1F1-10' },
    { length: '205" to 228"', model: 'MTG-RS-R1F1-11' },
    { length: '229" to 240"', model: 'MTG-RS-R1F1-12' },
    { length: '241" to 252"', model: 'MTG-RS-R1F1-13' },
    { length: '253" to 264"', model: 'MTG-RS-R1F1-14' },
    { length: '265" to 276"', model: 'MTG-RS-R1F1-15' },
    { length: '277" to 288"', model: 'MTG-RS-R1F1-16' }
];

const updateProbeLengthOptions = (probeType, answers, tankIndex) => {
    const probeLengthQuestion = questions.find(q => q.question === 'Probe Length');
    if (!probeLengthQuestion) return;

    const fuelType = answers[`What is the Product / Fuel Type in each Tank? - Tank ${tankIndex + 1}`];
    
    if (fuelType === 'DEF') {
        probeLengthQuestion.options = defProbeOptions.map(opt => opt.length);
        probeLengthQuestion.models = defProbeOptions.map(opt => opt.model);
    } else if (probeType === 'Leak Detection probe') {
        probeLengthQuestion.options = leakDetectionProbeOptions.map(opt => opt.length);
        probeLengthQuestion.models = leakDetectionProbeOptions.map(opt => opt.model);
    } else if (probeType === 'Inventory only probe') {
        probeLengthQuestion.options = inventoryProbeOptions.map(opt => opt.length);
        probeLengthQuestion.models = inventoryProbeOptions.map(opt => opt.model);
    }
};


const determineSensorModel = (sensorType, answers, tankIndex) => {
    const tankMaterial = answers[`Tank Material Type? - Tank ${tankIndex + 1}`];
    const tankDiameter = answers[`Inside diameter of tanks? - Tank ${tankIndex + 1}`];
    const isProductDistinguishing = answers['Is Product Distinguishing required for Interstice?'] === 'Yes';
    const isProductDistinguishingSump = answers['Is Product Distinguishing required for Sump/Dispenser Sensors?'] === 'Yes';
    const isBrine = answers['Is the interstice wet(BRINE)?'] === 'Yes';
    const uses2ConductorWiring = answers[`2-conductor field wiring for interstice sensors? - Tank ${tankIndex + 1}`] === 'Yes';
    const uses2ConductorWiringSump = answers[`2-conductor field wiring for sump/dispenser sensors?`] === 'Yes';
    const sensorOpening = answers['Opening for Interstice Sensor?'];
    const totalSumpSensors = parseInt(answers['How many Sump / Dispenser Sensors?']) || 0;
    const totalIntersticeSensors = parseInt(answers['How many Interstice Sensors?']) || 0;
    
    let models = new Set();

    

    if (sensorType === 'sump' && tankIndex < totalSumpSensors) 
    {
        if (uses2ConductorWiringSump) 
        {
            models.add('LSF');
            models.add('BX-UT');
        }
        else if (isProductDistinguishingSump) 
        {
            models.add('BX-PDS');
        }
        else 
        {
            models.add('BX-LS');
        }
    } 
    else if (sensorType === 'interstice' && tankIndex < totalIntersticeSensors) 
    {
        // Handle brine condition first
        if (isBrine) 
        {
            models.add('BX-RES');
            models.add('VC-1');
            return Array.from(models);
        }
        else if (uses2ConductorWiring) 
        {
            if(tankMaterial === 'Steel') 
            {
                models.add('LSF');
                models.add('BX-UT');
            } 
            else if(tankMaterial === 'Fiberglass') 
            {
                models.add('LF-DWF');
                models.add('BX-UT');
            }
        } 
        else 
        {
            if (isProductDistinguishing) 
            {
                //if yes for prod dist, no 2 conductor field wiring is possible.
                if (tankMaterial === 'Steel') 
                {
                    models.add(parseInt(tankDiameter) > 8 ? 'BX-PDWS' : 'BX-PDS');
                } 
                else if (tankMaterial === 'Fiberglass') 
                {
                    const size = tankDiameter.split(' ')[0];
                    models.add(`BX-PDWF-${size}`);
                } 
                else 
                {
                    models.add('BX-PDS');
                }
            } 
            else 
            {
                if (tankMaterial === 'Steel') 
                {
                    models.add(parseInt(tankDiameter) > 8 ? 'BX-LWS' : 'BX-LS');
                } 
                else if (tankMaterial === 'Fiberglass') 
                {
                    const size = tankDiameter.split(' ')[0];
                    models.add(`BX-LWF-${size}`);
                } 
                else 
                {
                    models.add('BX-LS');
                }
            }
        }
    }

    // Handle cap/sensor for interstice sensors based on opening size
    if (sensorOpening && models.size > 0 && sensorType === 'interstice') {
        if (sensorOpening === '2-inch') {
            models.add('2IN-CAP-S');
        } else if (sensorOpening === '4-inch') {
            models.add('4IN-CAP');
        } else if (sensorOpening === '1-inch') {
            // .895 sensors REPLACE the regular sensor for 1-inch openings
            // Remove any previously added sensors (BX-LS, BX-PDS, BX-LWS, etc.)
            const sensorsToRemove = ['BX-LS', 'BX-PDS', 'BX-LWS', 'BX-PDWS', 'LSF', 'LF-DWF'];
            sensorsToRemove.forEach(sensor => models.delete(sensor));
            // Also remove fiberglass variants
            models.forEach(model => {
                if (model.startsWith('BX-LWF-') || model.startsWith('BX-PDWF-')) {
                    models.delete(model);
                }
            });
            // Use BX-PDWS-.895 if product distinguishing is needed, otherwise BX-LWS-.895
            models.add(isProductDistinguishing ? 'BX-PDWS-.895' : 'BX-LWS-.895');
        }
    }

    return Array.from(models);
};

const getSectionForQuestion = (questionText) => {
    const question = questions.find(q => q.question === questionText);
    return question ? question.section : '';
};

const QuestionsModule = {
    initialQuestions,
    questions,
    getFilteredSections,
    determineInitialRecommendation,
    determineFinalRecommendation,
    updateProbeLengthOptions,
    leakDetectionProbeOptions,
    inventoryProbeOptions,
    getSectionForQuestion
};

export default QuestionsModule;

